<template>
    <div class="main-content">
        <h1>
            <translate>My success day activities</translate>
            <router-link :to="{name: 'plan-new-activity'}" class="button button--primary float-right">
                <translate>Plan new activity</translate>
            </router-link>
        </h1>
        <div class="main-content__my-success-day-activities">
            <div class="content-navigation">
                <ul class="content-navigation__container">
                    <li><a href="javascript:;" class="content-navigation__link"
                           v-bind:class="{ 'content-navigation__link--active' : tab_location == 'upcoming-activities' }"
                           @click="tab_location = 'upcoming-activities'" v-translate>Upcoming activities</a></li>
                    <li><a href="javascript:;" class="content-navigation__link"
                           v-bind:class="{ 'content-navigation__link--active' : tab_location == 'completed-activities' }"
                           @click="tab_location = 'completed-activities'" v-translate>Completed activities</a></li>
                </ul>
            </div>
            <div class="planned-activity__list" v-if="tab_location == 'upcoming-activities'">
                <div v-for="(activity, i) in upcoming_activities" :key="'upcomingactivity'+i">
                    <h3 v-if="checkIfMonthChanged(i,upcoming_activities)">{{activity.date|moment('MMMM')}}
                        {{activity.date|moment('YYYY')}}</h3>
                    <activity :activity="activity"/>
                </div>
                <div v-if="upcoming_activities.length == 0" class="empty-list" v-translate>
                    There are currently no upcoming activities.
                </div>
            </div>

            <div class="planned-activity__list" v-if="tab_location == 'completed-activities'">
                <div v-for="(activity, i) in completed_activities" :key="'completed_activity'+i">
                    <h3 v-if="checkIfMonthChanged(i,completed_activities)">{{activity.date|moment('MMMM')}}
                        {{activity.date|moment('YYYY')}}</h3>
                    <activity :activity="activity"/>
                </div>
                <div v-if="completed_activities.length == 0" class="empty-list" v-translate>
                    You did not yet complete any activity.
                </div>

                <!--
                <h3>September 2018</h3>
                <div class="planned-activity__item planned-activity__item--not-part-of-objective planned-activity__item--completed">
                    <div class="planned-activity__date">
                        <div class="planned-activity__day">12</div>
                        <div class="planned-activity__month">Sep</div>
                        <div class="planned-activity__year">2018</div>
                    </div>
                    <div class="planned-activity__title-and-category">
                        <a href="#VIEWACTIVITY#" @click="openPopup(activity_popup)">Name of your lorem ipsum dolor</a>
                        <div class="your-dates__category">
                            <span class="main-category-icon icon-dating" title="Category: Dating"></span> Subcategory
                        </div>
                    </div>
                    <div class="planned-activity__date-strength your-dates__date-strength">
                        Strength of the day for this activity was:
                        <div class="date-strength date-strength--great"><strong>Great</strong></div>
                    </div>
                    <div class="planned-activity__action-buttons">
                        <a href="#VIEWACTIVITY#" @click="openPopup(activity_popup)" class="button button--small button--gray">View</a>
                        <a href="#MARKASNOTCOMPLETED#" @click="openPopup(mark_as_not_completed_popup)" class="button button--small button--gray" title="Mark as not completed"><span class="icon icon-arrow-full"></span></a>
                    </div>
                </div>
                <div class="planned-activity__item planned-activity__item--not-part-of-objective planned-activity__item--completed">
                    <div class="planned-activity__date">
                        <div class="planned-activity__day">24</div>
                        <div class="planned-activity__month">Sep</div>
                        <div class="planned-activity__year">2018</div>
                    </div>
                    <div class="planned-activity__title-and-category">
                        <a href="#VIEWACTIVITY#" @click="openPopup(activity_popup)">Lorem ipsum dolor sit amet, consectetur adipisicing elit id, voluptatibus</a>
                        <div class="your-dates__category">
                            <span class="main-category-icon icon-real-estate" title="Category: Real Estate"></span> Subcategory
                        </div>
                    </div>
                    <div class="planned-activity__date-strength your-dates__date-strength">
                        Strength of the day for this activity was:
                        <div class="date-strength date-strength--great"><strong>Great</strong></div>
                    </div>
                    <div class="planned-activity__action-buttons">
                        <a href="#VIEWACTIVITY#" @click="openPopup(activity_popup)" class="button button--small button--gray">View</a>
                        <a href="#MARKASNOTCOMPLETED#" @click="openPopup(mark_as_not_completed_popup)" class="button button--small button--gray" title="Mark as not completed"><span class="icon icon-arrow-full"></span></a>
                    </div>
                </div>
                <h3>December 2018</h3>
                <div class="planned-activity__item planned-activity__item--not-part-of-objective planned-activity__item--completed">
                    <div class="planned-activity__date">
                        <div class="planned-activity__day">8</div>
                        <div class="planned-activity__month">Dec</div>
                        <div class="planned-activity__year">2018</div>
                    </div>
                    <div class="planned-activity__title-and-category">
                        <a href="#VIEWACTIVITY#" @click="openPopup(activity_popup)">Consectetur adipisicing elit a eos error maxime</a>
                        <div class="your-dates__category">
                            <span class="main-category-icon icon-income" title="Category: Business"></span> Subcategory
                        </div>
                    </div>
                    <div class="planned-activity__date-strength your-dates__date-strength">
                        Strength of the day for this activity was:
                        <div class="date-strength date-strength--great"><strong>Great</strong></div>
                    </div>
                    <div class="planned-activity__action-buttons">
                        <a href="#VIEWACTIVITY#" @click="openPopup(activity_popup)" class="button button--small button--gray">View</a>
                        <a href="#MARKASNOTCOMPLETED#" @click="openPopup(mark_as_not_completed_popup)" class="button button--small button--gray" title="Mark as not completed"><span class="icon icon-arrow-full"></span></a>
                    </div>
                </div>
                -->
            </div>
            <hr>
            <router-link :to="{name: 'plan-new-activity'}" class="button button--primary float-right" v-translate>
                Plan new activity
            </router-link>
        </div>
    </div>
</template>

<script>
    import ActivityPopup from './popups/ActivityPopup'
    import MarkAsCompletedPopup from './popups/MarkAsCompletedPopup'
    import {mapActions, mapState} from 'vuex';
    import MarkAsNotCompletedPopup from "./popups/MarkAsNotCompletedPopup";
    import axios from 'axios';
    import Activity from "./Activity";
    import moment from "moment";
    import {EventBus} from "../event-bus";
    import PackageFeatureRequired from "../mixins/PackageFeatureRequired";

    export default {
        name: 'Planning-MySuccessDayActivities',
        components: {Activity},
        mixins: [PackageFeatureRequired('plan_your_success_day')],
        data() {
            return {
                activities: [],
                tab_location: 'upcoming-activities',
                activity_popup: ActivityPopup,
                mark_as_completed_popup: MarkAsCompletedPopup,
                mark_as_not_completed_popup: MarkAsNotCompletedPopup
            }
        },
        computed: {
            ...mapState(['user_data']),
            upcoming_activities: function () {
                return this.activities.filter(activity => activity.completed === false)
            },
            completed_activities: function () {
                return this.activities.filter(activity => activity.completed === true)
            }
        },
        methods: {
            ...mapActions([
                'openPopup',
            ]),
            checkIfMonthChanged: function (i, activities_list) {
                if (i == 0) {
                    return true;
                } else if (moment(activities_list[i - 1].date).month() != moment(activities_list[i].date).month() || moment(activities_list[i - 1].date).year() != moment(activities_list[i].date).year()) {
                    return true;
                } else {
                    return false;
                }
            },
            loadActivities: async function () {
                this.activities = (await axios.get('/api/navigator/activities/')).data
            }
        },
        beforeMount: async function () {
            await this.loadActivities()
        },
        created: function () {
            EventBus.$on('refresh_activities', this.loadActivities)
        },
        beforeDestroy: function () {
            EventBus.$off('refresh_activities')
        }

    }
</script>